module.exports = __webpack_public_path__ + "static/media/23.9b83ee7f.jpg";